import { useState, useContext, useEffect } from "react";
import { UserContext } from "../../../context/UserContext";
import { IBackBehavior, UserCtx } from "../../../interfaces";

import { makeStyles } from "@mui/styles";
import { Box, Typography, Stack, SvgIcon } from "@mui/material";
import { ButtonZoom } from "../utils/ButtonZoom";
import { ReactComponent as ArrowIcon } from "../../../assets/ArrowRightWhiteIcon.svg";
import { SingleStreakStar } from "../home/SingleStreakStar";
import { generateGtmEvent } from "../../../Helpers";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 439,
    position: "relative",
  },
  button: {
    width: 195,
    padding: "0px",
  },
  arrow: {
    marginLeft: "8px",
    width: "17px",
    height: "19px",
  },
  pinkText: {
    color: theme.palette.secondary.main,
  },
}));

const days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
const reverse = (dayIndex: number) => {
  let split = (3 - dayIndex) * -1;
  let firstHalf = days.slice(0, split).reverse();
  let secondHalf = days.slice(split, days.length).reverse();
  let arr = firstHalf.concat(secondHalf).reverse();
  return arr;
};

interface WrapperStreakModalContentProps {
  streakModalInLearning: boolean;
  backBehavior: IBackBehavior;
  handleContinue: () => void;
  handleGoHome: () => void;
}

const HandleDataLayer = (
  event: string,
  action: string,
  name: string,
  type: string,
  region: string,
  section: string,
  text: string
) => {
  generateGtmEvent({ event, action, name, type, region, section, text });
};

export const WrapperStreakModalContent = (props: WrapperStreakModalContentProps) => {
  const classes = useStyles();

  const [rotatedArr, setRotatedArr] = useState<string[]>([]);
  const [filledStar, setFilledStar] = useState<string[]>([]);

  const userCtx = useContext(UserContext) as UserCtx;
  const filledIndex = userCtx.userStreak;
  let todaysDay = new Date().getDay();

  useEffect(() => {
    if (filledIndex.length === 0) {
      return;
    }
    if (filledIndex.length >= 7) {
      setFilledStar(days);
      return;
    }
    for (var i = 0; i < filledIndex.length; i++) {
      let day = days[new Date(filledIndex[i]).getDay()];
      setFilledStar((prev) => {
        return [...prev, day];
      });
    }
  }, [filledIndex]);
  useEffect(() => {
    setRotatedArr(reverse(todaysDay));
  }, [todaysDay]);

  return (
    <Box className={classes.root}>
      <Box sx={{ marginBottom: "32px", padding: "0px 24px" }}>
        <Typography variant="h3" sx={{ marginBottom: "12px" }}>
          {filledIndex.length > 1 ? (
            <div>
              <span className={classes.pinkText}>{filledIndex.length} Day </span>
              streak!
            </div>
          ) : (
            <div>Congrats, you earned your first streak!</div>
          )}
        </Typography>
        <Typography variant="body2">
          {filledIndex.length > 1
            ? "Practice everyday so that it doesn’t reset to zero."
            : "Complete another activity tomorrow to continue your streak."}
        </Typography>
      </Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        {rotatedArr.map((day, index) => (
          <SingleStreakStar
            key={index}
            day={day}
            isFilled={filledStar.includes(day)}
            isCenter={index === (rotatedArr.length - 1) / 2}
            circleSize={{ center: 67, default: 45 }}
            iconSize={{ center: 35, default: 22 }}
            animateOverride={true}
          />
        ))}
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginTop: "48px", padding: "0px 14px" }}>
        <ButtonZoom
          className={classes.button}
          size="large"
          variant="contained"
          color="primary"
          onClick={() => {
            HandleDataLayer(
              "link",
              "click",
              "onclick",
              "internal link",
              "main content",
              filledIndex.length > 1
                ? `${filledIndex.length} day streak!`
                : "congrats, you earned your first streak!",
              filledIndex.length > 1 ? "go back home" : "continue"
            );
            props.handleGoHome();
          }}>
          {props.streakModalInLearning ? "Go back home" : "Continue"}
        </ButtonZoom>
        {props.streakModalInLearning && (
          <ButtonZoom
            className={classes.button}
            size="large"
            variant="contained"
            color="secondary"
            onClick={() => {
              HandleDataLayer(
                "link",
                "click",
                "onclick",
                "internal link",
                "main content",
                filledIndex.length > 1
                  ? `${filledIndex.length} day streak!`
                  : "congrats, you earned your first streak!",
                "continue"
              );
              props.handleContinue();
            }}>
            Continue
            <SvgIcon className={classes.arrow}>
              <ArrowIcon />
            </SvgIcon>
          </ButtonZoom>
        )}
      </Stack>
    </Box>
  );
};
